import { SYSTEM_USER_ID } from 'src/util/constants';

/**
 * Generates a display name for a user based on their email, given name, and family name.
 * Returns an internationalized 'System' label when userId === SYSTEM_USER_ID
 * or user.id === SYSTEM_USER_ID.
 * @param {import('react-intl').IntlShape} intl - The intl object for internationalization.
 * @param {object} user - The user object containing email, givenName, and familyName properties.
 * @param {string} [userId=null] - The user's ID.
 * @returns {string | null} The display name for the user.
 */
const displayUserName = (intl, user, userId = null) => {
  if (!user && userId !== SYSTEM_USER_ID) {
    return null;
  }

  if (user?.id === SYSTEM_USER_ID || userId === SYSTEM_USER_ID) {
    return intl.formatMessage({
      id: 'util.i18n.decorators.display_user_name.system.label',
      defaultMessage: 'System',
    });
  }

  const { email, givenName, familyName } = user;
  const name = [givenName, familyName].filter(Boolean).map((n) => n.trim()).filter(Boolean).join(' ');

  return (name === '' ? email : name);
};

export default displayUserName;
